import Link from "next/link";
import Image from "next/image";

export default function AgencyTile({ agency }) {
 const referralLink = `/lex-cms/agency_referral/${agency.id}?link=${encodeURIComponent(agency.url)}`
  return (
    <div className="lexcms-agent-locator-agency-tile" id={"lexcms-agency-"+agency.id}>
      <div className="lexcms-agent-locator-agency-tile-logo-area">
        <Image src={agency.logo} height={140} width={300} alt={""} />
      </div>
      <div className="lexcms-agent-locator-agency-tile-text-area">
        <h3 className="lexcms-agent-locator-agency-tile-name">
          {agency.name}
        </h3>
        {agency.no_rep_message &&
         <p className='lexcms-agent-locator-no-rep'><strong >{agency.no_rep_message}</strong></p>

        }
        <div className="lexcms-agent-locator-agency-tile-info-area">
        <p className="lexcms-agent-locator-agency-tile-info">
          {agency.address_1}
        </p>
        {agency.address_2 &&
        <p className="lexcms-agent-locator-agency-tile-info">
          {agency.address_2}
        </p>
        }
        {!agency.is_foreign_address &&
        <p className="lexcms-agent-locator-agency-tile-info">{agency.city}, {agency.state}</p>
         }
        {agency.is_foreign_address && 
        <p className="lexcms-agent-locator-agency-tile-info">{agency.foreign_address}</p>
        }
        {agency.country &&
          <p className="lexcms-agent-locator-agency-tile-info">{agency.country}</p>
          }
        <p className="lexcms-agent-locator-agency-tile-info">{agency.phone_1}</p>
        <p className="lexcms-agent-locator-agency-tile-info">
            {agency.time_zone}
        </p>

        </div>
      </div>
      <div className="lexcms-agent-locator-agency-tile-website-link-area">
          {!agency.no_rep_message &&
          <a href={referralLink} target='_blank'>
            <p className="lexcms-agent-locator-agency-tile-website-link">
              Visit Agency Website
            </p>
          </a>
           }
      </div>
    </div>
  );
}
